<template>
  <main id="payouts-single" class="site-main">
    <div class="grid-container">
      <div class="single-detail">
        <div class="single-detail__header">
          <div class="grid-x align-bottom">
            <div class="cell shrink">
              <h1 style="font-size: 30px; margin: 0 15px 0 0;">Payout
                Details</h1>
            </div>

            <div class="cell shrink">
              {{ data.created_date }}
            </div>

            <div class="cell auto text-right">
              <div style="font-size: 24px; font-weight: 700;">
                {{ data.amount }}
              </div>
            </div>
          </div>

                    <div class="text-right" style="padding-top: 15px;">
                      <button @click="report" v-if="$store.state.portalSettings.myshopify_domain !== 'painted-door-on-main.myshopify.com'">Print Invoice</button>
                        <button @click="report" v-else>Print Report</button>
                    </div>
        </div>

        <div class="grid-x" style="margin-bottom: 30px;">
          <div class="cell">
            <p>{{ data.note }}</p>
          </div>
        </div>
      </div>

      <div class="grid-x grid-padding-x">
        <div class="cell auto">
          <div class="panel no-padding">
            <!--            <searchBar placeholder="Search line items" @sort="sort"-->
            <!--                       :value="searchValue"-->
            <!--                       @search="search"></searchBar>-->

            <div :class="['loading-area', loading ? 'loading' : '']">
              <div :class="['loading-area__content', loading ? 'loading' : '']">
                <!--                <pagination :prev="prev" :next="next" :start="start" :end="end"-->
                <!--                            :total="total"-->
                <!--                            @paginate="paginate"></pagination>-->

                <tableList :header="tableHeader" :data="tableData"
                           :loading="loading" classes="no-hover"
                           @sort="orderBy"></tableList>

                <!--                <pagination :prev="prev" :next="next" :start="start" :end="end"-->
                <!--                            :total="total"-->
                <!--                            @paginate="paginate"></pagination>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import {API_ROOT_URL} from '@/localSettings'

import moment from 'moment'
import axios from 'axios'

export default {
  mixins: [client, paginationUtils],
  data: function () {
    return {
      action: '/vendors/payouts/' + this.$route.params.id + '/?expand=line_items_w_order',
      sort: '-created_date',
      loading: true,
      tableHeader: {
        currentSort: '-created_date',
        data: [
          {
            label: 'Order'
          },
          {
            label: 'Product',
            class: 'full'
          },
          // {
          //   label: 'Customer',
          //   class: 'medium show-for-xlarge'
          // },
          // {
          //   label: 'Fulfillment',
          //   class: 'medium'
          // },
          {
            label: 'Price'
          },
          {
            label: 'Commission'
          },
          {
            label: 'Date',
            class: 'large'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    report () {
      axios({
        method: 'post',
        url: API_ROOT_URL + '/vendors/export-payout/?id=' + this.$route.params.id
      }).then((response) => {
        if (response.status === 200) {
          let link = document.createElement('a')
          link.download = 'payout.pdf'
          link.href = response.data
          link.target = '_blank'
          link.textContent = 'Download payouts.csv'

          link.click()
        }
      })
    },
    buildTable () {
      this.data.amount = this.formatMoney(this.data.amount)

      let lineItems = this.data.line_items
      this.data.created_date = moment(this.data.created_date).format('MMM D, YYYY [at] h:mma')

      for (let i = 0; i < lineItems.length; i++) {
        let lineItem = lineItems[i].line_item

        lineItem.date = moment(lineItem.order.processed_at).format('MMM D, YYYY [at] h:mma')
        lineItem.financial_status = 'paid'
        lineItem.financialLabel = 'success'
        lineItem.customer_name = 'N/A'

        this.price = this.formatMoney(this.data.price)

        lineItem.fulfillmentStatus = lineItem.fulfillment_status

        if (lineItem.fulfillment_status === 'partial') {
          lineItem.fulfillmentLabel = 'warning'
          lineItem.fulfillmentStatus = 'Partially Fulfilled'
        } else if (lineItem.fulfillment_status === 'restocked' ||
          lineItem.fulfillment_status === null) {
          lineItem.fulfillmentLabel = 'alert'
        } else {
          lineItem.fulfillmentLabel = 'success'
        }

        if (lineItem.fulfillment_status === null) {
          lineItem.fulfillmentStatus = 'Unfulfilled'

          lineItem.fulfillmentStatus = this.formatText(lineItem.fulfillmentStatus)
        }

        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image">'

        if (!this.isEmpty(lineItem.image) && lineItem.image !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + lineItem.image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
        }

        if (lineItem.variant !== null) {
          if (lineItem.variant.product !== null) {
            primary += '</div></div><div class="cell auto" style="overflow: hidden; text-overflow: ellipsis;"><span style="white-space: nowrap;">' + lineItem.variant.product.title + '</span>'
          } else {
            primary += '</div></div><div class="cell auto">'
          }

          if (lineItem.variant !== null && lineItem.variant.title !== null && lineItem.variant.title.length > 0 && lineItem.variant.title !== 'Default Title') {
            primary += '<br><span class="text-overflow"><small><i>' + lineItem.variant.title + '</i></small></span>'
          }
        } else {
          primary += '</div></div><div class="cell auto">'

          if (lineItem.title !== null && lineItem.title.length > 0) {
            primary += '<span class="text-overflow">' + lineItem.title + '</span>'
          } else {
            primary += '<span class="text-overflow">' + lineItem.name + '</span>'
          }
        }

        if (lineItem.sku !== null && lineItem.sku.length > 0) {
          primary += '<br><span class="text-overflow"><small><i>' + lineItem.sku + '</i></small></span>'
        }

        primary += '</div></div>'

        let priceCol = {}

        if (this.metas.vendor_field_sell_price.meta_value) {
          let price = '<div class="grid-x align-middle"><div class="cell shrink">' + this.formatMoney(lineItem.price)

          if (this.metas.vendor_field_discount && lineItem.allocated_discount > 0) {
            price += '<div class="text-right">-' + this.formatMoney(lineItem.allocated_discount) + '</div>'
          }

          price += '</div><div class="cell auto text-right" style="white-space: nowrap;">x ' + lineItem.quantity + '</div></div>'

          priceCol = {
            value: price,
            span: 'fill'
          }
        }

        let commissionCol = {}

        if (this.metas.vendor_field_commissions.meta_value) {
          let commission = this.formatMoney(lineItems[i].amount)

          commissionCol = {
            value: commission,
            span: 'focus-text'
          }
        }

        let order = {}

        if (this.metas.vendor_field_order_num.meta_value !== false) {
          order = {
            value: lineItems[i].line_item.order.name
          }
        }

        let date = {}

        if (this.metas.vendor_field_order_date.meta_value !== false) {
          date = {
            value: lineItem.date,
            class: 'large'
          }//
        }

        this.tableData.push({
          data: [
            order,
            {
              value: primary,
              class: 'full'
            },
            // {
            //   value: lineItem.customer_name,
            //   class: 'medium show-for-xlarge'
            // },
            // {
            //   value: this.formatText(lineItem.fulfillment_status),
            //   class: 'medium',
            //   span: 'label ' + lineItemFulfillmentStatus
            // },
            priceCol,
            commissionCol,
            date
          ]
        })

        this.loading = false
      }
    }
  },
  computed: {
    metas () {
      return this.$store.state.metas
    }
  },
  created () {
    if (this.metas.vendor_field_order_date.meta_value === false) {
      this.tableHeader.data[4] = {}
    }

    if (!this.metas.vendor_field_commissions.meta_value) {
      this.tableHeader.data[3].label = ''
    }

    if (!this.metas.vendor_field_sell_price.meta_value) {
      this.tableHeader.data[2].label = ''
    }

    if (this.metas.vendor_field_order_num.meta_value === false) {
      this.tableHeader.data[0] = {}
    }

    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/payoutsSingle.vue